import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as CubiqServices from "shared/cubiq-services";
import { BfxPopupNotificationData } from "./bfx-popup-notification-data.model";
import { BfxPopupNotificationCommand } from "./bfx-popup-notification-command.enum";
import { BfxBlotterOrdersContextMenuItemAcceptanceState } from "shared/cubiq-services";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";

export class BfxPopupAcceptanceExpiryNotificationData extends BfxPopupNotificationData {
  public acceptanceState: BfxBlotterOrdersContextMenuItemAcceptanceState;

  constructor(
    private activeUser: CubiqServices.ActiveUser,
    private hasAccept: boolean,
    private hasUnrestricted: boolean,
  ) {
    super(
      BFXNotificationType.ACCEPTANCE_NEEDED,
      "icon-bfx_expired",
      BFXNotificationSubType.ACCEPTANCE_EXPIRY,
    );
    this.acceptanceState = new BfxBlotterOrdersContextMenuItemAcceptanceState();
    this.acceptanceState.actionRequests = {
      accept: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      acceptInto: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      reject: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
    };
  }

  reInitMaps() {
    this.acceptanceState.actionRequests.accept.acceptance.clear();
    this.acceptanceState.actionRequests.accept.xfer.clear();
    this.acceptanceState.actionRequests.acceptInto.acceptance.clear();
    this.acceptanceState.actionRequests.acceptInto.xfer.clear();
    this.acceptanceState.actionRequests.reject.acceptance.clear();
    this.acceptanceState.actionRequests.reject.xfer.clear();
  }

  private addToAcceptMap(orderId: string) {
    if (!this.acceptanceState.actionRequests.accept.acceptance.has(CubiqTS.AcceptanceType.EXPIRY)) {
      this.acceptanceState.actionRequests.accept.acceptance.set(CubiqTS.AcceptanceType.EXPIRY, []);
    }
    this.acceptanceState.actionRequests.accept.acceptance
      .get(CubiqTS.AcceptanceType.EXPIRY)
      .push(orderId);
  }

  protected updateAllowableActions() {
    this.actions = [];
    this.reInitMaps();
    if (
      this.hasUnrestricted ||
      (this.activeUser.userTypeId === CubiqTS.UserType.TRADER && this.hasAccept)
    ) {
      let acceptCount: number = 0;

      this.payload.forEach((item) => {
        if (
          this.hasUnrestricted ||
          (this.hasAccept &&
            (item.as_fv_deskId === "-1" ||
              this.activeUser.tradingGroupsIds.indexOf(item.as_fv_deskId) > -1))
        ) {
          acceptCount++;
          this.addToAcceptMap(item.orderId);
        }
      });

      if (acceptCount == this.payload.length) {
        this.actions.push({
          label: "Accept",
          command: BfxPopupNotificationCommand.POPUP_DI_ACCEPT,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
    }
  }

  destroy() {
    super.destroy();
    this.activeUser = null;
  }
}
